import React, { useContext, useEffect } from "react";
import MainTitle from "components/MainTitle";
import FormContainer from "components/FormContainer";
import Fieldset from "components/Fieldset";
import Legend from "components/Legend";
import FormActions from "components/FormActions";
import { Button } from "mondrian-react";
import { store } from "../../store.js";

const ShowEmail = ({ setForm, formData, navigation, isLoading }) => {
  const { next } = navigation;
  const globalState = useContext(store);
  const { state, dispatch } = globalState;
  const userEmail = state.emailData?.newEmail
    ? state.emailData.newEmail
    : state.user?.email;

  useEffect(
    function () {
      dispatch({
        type: "SET_GA",
        payload: { flow: "alterar-email" },
      });
    },
    [dispatch]
  );
  let userEmailText = userEmail
    ? "Seu e-mail de login é: " +
      (Array.isArray(userEmail) ? userEmail[0] : userEmail)
    : "Você ainda não possui um e-mail de login";
  let buttonEmailText = userEmail ? "Alterar e-mail" : "Cadastrar e-mail";
  return (
    <>
      <FormContainer id="form">
        <MainTitle sm tabIndex="20">
          {buttonEmailText}
        </MainTitle>
        <Fieldset>
          <Legend>{!isLoading ? userEmailText : ""}</Legend>
          <FormActions>
            <Button
              onClick={next}
              disabled={false}
              type={"submit"}
              tabIndex="20"
            >
              {buttonEmailText}
            </Button>
          </FormActions>
        </Fieldset>
      </FormContainer>
    </>
  );
};

export default ShowEmail;
